import { useContext } from "react";
import { EmployeeManagerContext, EmployeeManagerActionType, OrganisationManagerContext, OrganisationManagerActionType, LoggedInContext } from "@Contexts";
import { Employee } from "@Models/Employee";
import { PrivateApiClient } from "../ApiClient";


export const useDeleteEmployee = () => {
    const { currentUser } = useContext(LoggedInContext);
    const { organisation, dispatch: dispatchOrganisation } = useContext(OrganisationManagerContext);
    const { dispatch: dispatchEmployee } = useContext(EmployeeManagerContext);

    async function performDelete(employee:Employee) {
        const client = new PrivateApiClient().withUser(currentUser);
        if (employee.sub) {
            const managedTeams = [... organisation.teamsManagedBy(employee.sub)];
            for(let teamId of managedTeams) {
                await client.updateOrganisation({
                    teams: {
                        [teamId]: {
                            managerId: 'deleted',
                            name: organisation.teams[teamId].name
                        }
                    }
                });
                organisation.teams[teamId].managerId = 'deleted';
                dispatchOrganisation({ type: OrganisationManagerActionType.TeamUpserted, team: organisation.teams[teamId], teamId: teamId })
            }
        }
        const writeModel = Employee.createWriteModel(employee);
        await client.deleteEmployee(writeModel);

        dispatchEmployee({ type: EmployeeManagerActionType.EmployeeDeleted, employee })
    }

    return {
        performDelete
    };
}